var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4461 4.04488L11.9555 0.553473C11.8394 0.43737 11.7016 0.34527 11.5499 0.282434C11.3982 0.219598 11.2357 0.187256 11.0715 0.187256C10.9073 0.187256 10.7447 0.219598 10.5931 0.282434C10.4414 0.34527 10.3036 0.43737 10.1875 0.553473L0.553912 10.1878C0.437334 10.3035 0.344907 10.4412 0.282006 10.5929C0.219104 10.7446 0.186982 10.9072 0.187506 11.0714V14.5628C0.187506 14.8944 0.319202 15.2123 0.553623 15.4467C0.788043 15.6812 1.10599 15.8128 1.43751 15.8128H4.92891C5.09313 15.8134 5.2558 15.7813 5.40749 15.7183C5.55918 15.6554 5.69685 15.563 5.81251 15.4464L15.4461 5.81285C15.5622 5.69677 15.6543 5.55896 15.7171 5.40728C15.78 5.25561 15.8123 5.09304 15.8123 4.92886C15.8123 4.76469 15.78 4.60212 15.7171 4.45044C15.6543 4.29877 15.5622 4.16096 15.4461 4.04488ZM12.6875 6.80347L9.1961 3.31285L11.0711 1.43785L14.5625 4.92847L12.6875 6.80347Z",
    fill: "#C7C7C7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPencil);
export default __webpack_public_path__ + "static/media/edit-pencil.be3a693758b94efe6dbb5fd8204a3324.svg";
export { ForwardRef as ReactComponent };